import ErrorBoundary from "components/ErrorBoundary";
import React, { useState, useEffect } from "react";
import { Card, CardBody, Row, Container, Label, Col, Button, InputGroup, FormGroup, InputGroupText } from "reactstrap";
// import CEConfigurationTabs from "components/CEConfigurationTabs";
import useAxios from "hooks/useAxios";
// import { dateOnly } from "utils/columns";
import Calendar from 'assets/icon/calendar-icon.svg';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { Field, Formik } from "formik";
import Arrow from 'assets/icon/LeftChevron.svg'
import Cancel from "src/assets/icon/cancel.svg";
import EditIcon from "assets/icon/edit.svg"
import save from "assets/icon/save.svg";
import Addicon from "assets/icon/EditConfig.svg";





const ChainPharmacyDetailsTab = (props) => {
  const {
    selectChainPharmacyName , 
    thirdPartyAdminID,
    searchTerms,
    setConfigRules,
    tenantID,
    search,
    rowconfig,
    setRowConfig,
    editConfigtoggle,
    setEditConfigToggle,
    setClientCongigToggle,
    clientConfigtoggle,
    data 
  } = props;

  const API = useAxios();

 const [cPStatus , setCPStatus] = useState() ;
  useEffect(() => {
     if (thirdPartyAdminID != 0 && selectChainPharmacyName.value != "") {
       fetchChainPharmcyDetails();
     }
   }, [thirdPartyAdminID, selectChainPharmacyName]);
 
  
  const fetchChainPharmcyDetails = async () => {
    try {
      const { searchTerms } = props;
      const { data } = await API.get(
        `GWConfig/Configuration/chainpharmacy/${thirdPartyAdminID}/${selectChainPharmacyName.value}`,
        {
          hasDefaultURL: true,
        }
      );

      if (data) {
        setCPStatus(data);
      }
    } catch (err) { }
  };


  const handelClickimage = () => {
    setRowConfig(true);
    setClientCongigToggle(false);
    setConfigRules(false)
  };


 
  return (
    <div>
      {/* <Container fluid className="my-3"> */}
      <Card className="border-0 shadow-top my-3">
        <CardBody className="section-devider-border">
          <ErrorBoundary>
            <Row>
              <div className="d-flex align-items-center">
                <h4
                  className="f-16 text-primary font-weight-700"
                  style={{ cursor: "pointer", marginRight: "auto" }}
                  onClick={handelClickimage}
                >
                  <span
                    style={{
                      paddingRight: "5px",
                      position: "relative",
                      top: "-1px",
                      cursor: "pointer",
                    }}
                  >
                    <img style={{ width: "9px" }} src={Arrow} />
                  </span>{" "}
                  Chain Pharmacy Details {" "}
                </h4>


              </div>


              <Col md="4">
                <p className="mt-2 f-14 mb-0 ">Chain Pharmacy Name</p>
                <p className="mt-2 f-14 font-weight-500 ">
                  {cPStatus ? cPStatus[0].chainPharmacyName : "" }
                </p>
              </Col>  
            

              <Col md="4">
                <p className="mt-2 f-14 mb-0">Chain Pharmacy Status</p>
                <p className="mt-2 f-14 font-weight-500 ">
                  {cPStatus ? cPStatus[0].chainPharmacyStatus : ""}
                </p>
              </Col>

         


            </Row>
          </ErrorBoundary>






        </CardBody>
      </Card>



    </div>
  );
};

export default ChainPharmacyDetailsTab;
